/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".document-dropzone[_ngcontent-%COMP%]{display:block;position:relative}.dropped-fields-zone[_ngcontent-%COMP%]{position:absolute;top:0;bottom:10px;left:0;right:0;z-index:5;overflow:hidden}"];
export { styles as styles };
